import React, { Component } from 'react';
import styled from 'styled-components';
import api from 'api';
import css from 'css';

import AspectRatio from 'partials/AspectRatio';

class RelatedArticles extends Component {
	constructor() {
		super();

		this.state = {
			blogs: []
		}
	}

	componentDidMount() {
		this._loadBlogPosts();
	}

	_loadBlogPosts = () => {
		api.blogFetcher.getPosts({per_page: 2}).then(response => {
			this.setState({ blogs: response.data.splice(0,2) });
		});
	}

	render() {

		const { blogs } = this.state;
		const { data } = this.props;
		if(!blogs.length > 0) return null;

		return(
			<Container>
				<BlogHeader>
					<div className="title">{ data.title || 'Blogg'}</div>
					<a className="url" href="/blogg">{ data.url_title || 'Blogg oversikt'}</a>
				</BlogHeader>
				{ blogs.length > 0 && blogs.map((blog, index) => {
					return(
						<BlogPost id={index}>
							<StyledAspectRatio url={blog.acf.feature_photo.url} className="image" w="480" h="320" background ratio="1:1" />
							<a className="title" href={blog.link} ><h3>{blog.post_title || blog.title.rendered}</h3></a>
							<p>{blog.acf.ingress}</p>
						</BlogPost>
					)
				})}
			</Container>
		);
	}
}

export default RelatedArticles;

const Container = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	padding-bottom: 60px;
	max-width: 1260px;
	margin: 0 auto;
	justify-content: center;

	@media(max-width: 1024px) {
		padding-left: 0px;
	}
`;

const BlogHeader = styled.div`
	flex: 0 0 100%;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	justify-content: center;

	.title {
		${css.fonts.SSProSemiBold};
		font-size: 32px;
		color: #002857;
		line-height: 42px;
		min-width: 480px;
	}

	.url {
		${css.fonts.SSProRegular};
		font-size: 16px;
		color: #002857;
		line-height: 24px;
		min-width: 480px;
		text-align: end;
		text-decoration: underline;
	}

	@media(max-width: 1024px) {
		justify-content: space-between;
		padding: 0 20px;
		.title {
			min-width: 0px;
		}
		.url {
			min-width: 0px;
		}
	}

	@media(max-width: 767px) {
		padding: 0 20px;
	}

`;

const StyledAspectRatio = styled(AspectRatio)`
	 padding-bottom: 320px;
`;


const BlogPost = styled.div`
	flex: 0 0 50%;
	max-width: 480px;

	padding-top: 60px;

	.title {
		${css.fonts.SSProSemiBold};
		font-size: 24px;
		color: #002857;
		line-height: 34px;
	}

	p {
		${css.fonts.SSProRegular};
		font-size: 16px;
		color: #002857;
		line-height: 24px;
		padding-top: 25px;
	}

	&:nth-child(3) {
		padding-left: 40px;
	}

	@media(max-width: 1024px) {
		flex: 0 0 50%;
		padding: 20px;

		&:nth-child(3) {
			padding-left: 20px;
		}
	}

	@media(max-width: 767px) {
		flex: 0 0 100%;
		padding: 20px;

		&:nth-child(3) {
			padding-left: 20px;
		}
	}
`;



// WEBPACK FOOTER //
// ./src/partials/modules/RelatedArticles/RelatedArticles.js